import moment from "moment";

export default interface ISampleFormData {
  isEditMode: boolean;
  requestId: string;
  id: string;
  name: string;
  description: string;
  productId: string;
  sourceId: string;
  orderId: string;
  setId: string;
  sampleDate: string;
  sourceName: string;
  productName: string;
  formatedDate: any;
  gradeId?: string;
  gradeName?: string;
  testplanId?: string;
  testplanName?: string;
  measurementId?: string;
}

export class SampleFormData implements ISampleFormData {
  isEditMode: boolean;
  requestId: string;
  id: string;
  name: string;
  description: string;
  productId: string;
  sourceId: string;
  orderId: string;
  setId: string;
  sampleDate: string;
  sourceName: string;
  productName: string;
  formatedDate: any;

  gradeId?: string;
  gradeName?: string;
  testplanId?: string;
  testplanName?: string;
  measurementId?: string

  constructor(
    isEditMode: boolean,
    requestId: string,
    id: string,
    name: string,
    descriptions: string,
    productId: string,
    sourceId: string,
    orderId: string,
    setId: string,
    sampleDate: string,
    sourceName: string,
    productName: string,
    measurementId?: string,
    gradeId?: string,
    testplanId?: string
  ) {
    this.isEditMode = isEditMode;
    this.requestId = requestId;
    this.id = id;
    this.name = name;
    this.description = descriptions;
    this.productId = productId;
    this.sourceId = sourceId;
    this.orderId = orderId;
    this.setId = setId;
    this.sampleDate = sampleDate;
    this.sourceName = sourceName;
    this.productName = productName;
    this.formatedDate = this.sampleDate ? moment(this.sampleDate).format("MM/D/YYYY h:mm a") : null;
    if (measurementId && measurementId !=="") {
      this.measurementId = measurementId
    }
    this.gradeId = gradeId;
    this.testplanId = testplanId;
  }
}

const defaultSampleFormData = new SampleFormData(false, "", "", "", "", "", "", "", "", "", "", "","","","");
export { defaultSampleFormData };
